import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

function KycReturn() {
  const [params] = useSearchParams();

  useEffect(() => {
    const merchantId = params.get("merchantId");
    console.log("Merchant ID:", merchantId);

    if (merchantId) {
      // backend ko hit kar
      fetch("/api/v1/member/topay/onboard", {
        method: "POST",
        headers: {
          "Authorization": "Bearer TOKEN",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ merchantId })
      });
    }
  }, []);

  return <h2>KYC Processing...</h2>;
}

export default KycReturn;